import { useContext, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setCart } from "../../redux";

import { useFormatText } from "../../hooks/useFormatText";
import { LangContext } from "../../context/LangContext";
import { useGoPage } from "../../hooks/useGoPage";

import SelectLang from "../../components/SelectLang";
import Slider from "../../components/Slider";
import ModalShop from "../../components/ModalShop";

import "./style.css"

import icon_cart from '../../assets/svg/basket.svg'

function Article({ article }) {
    const goPage = useGoPage();
    const dispatch = useDispatch();
    const formatText = useFormatText();

    const cart = useSelector(state => state.cart);
    const { language, translations } = useContext(LangContext);

    const [modal, setModal] = useState(null);
    const [quantity, setQuantity] = useState('');
    const [selected, setSelected] = useState(null);
    const [animCart, setAnimCart] = useState('');

    const verif1 = article.multi_qty !== undefined && article.selectors.length !== 0;
    const verif2 = article.multi_qty === undefined && article.selectors.length === 0;
    const verif = verif1 || verif2;

    useEffect(() => {
        if (article.selectors.length !== 0) setSelected(0);

        // Get and Check last cart
        const lastCart = JSON.parse(localStorage.getItem('cart_vanrah'));
        if (!lastCart) return

        const checkLastCart = async (lastCart) => {
            let newCart = [];

            for (let prod of lastCart) {
                const req = await fetch(`${process.env.REACT_APP_API_URL}/articles/get/${prod.title_path}`);
                const res = await req.json();

                newCart.push({ ...prod, exist: res ? true : false });
            }
            dispatch(setCart(newCart));
        }
        checkLastCart(lastCart);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [article]);

    function formatDecimal(value) {
        const num = Number(value);
        if (Number.isNaN(num)) {
            goPage('error');
            return
        };

        // arrondi à 2 décimales, puis on reformate
        return (
            num
                .toFixed(2)                 // "123456.00"
                .replace('.', ',')          // étape intermédiaire pour la regex
                .replace(/\B(?=(\d{3})+(?!\d))/g, ' ') // séparateur de milliers
                .replace(',', '.')          // on remet le point
        );
    }

    function updateQuantity(e) {
        if (e.target.value <= 0) return
        setQuantity(e.target.value);
    }

    const addToCart = () => {
        if (quantity <= 0) return
        let newCart = [...cart];

        const alreadyExistingIndex = newCart.findIndex((a) => {
            if (a.title_path !== article.title_path) return false;
            if (article.selectors?.length) {
                return a.category_fr === article.selectors[selected]?.name_fr;
            }
            return true;
        });

        if (alreadyExistingIndex === -1) {
            const newItem = {
                id: article._id,
                title_path: article.title_path,
                title_fr: article.title_fr,
                title_en: article.title_en,
                image: article.images[0] || null,
                price: article.price,
                quantity: Number(quantity),
                exist: true,
            };


            if (article.selectors?.length && selected !== null) {
                newItem.category_fr = article.selectors[selected].name_fr;
                newItem.category_en = article.selectors[selected].name_en;
            }

            newCart.push(newItem);
        }
        else {
            const updatedItem = {
                ...newCart[alreadyExistingIndex],
                quantity: Number(newCart[alreadyExistingIndex].quantity) + Number(quantity),
                exist: true,
            };
            newCart[alreadyExistingIndex] = updatedItem;
        }

        localStorage.setItem("cart_vanrah", JSON.stringify(newCart));
        dispatch(setCart(newCart));
        window.scrollTo(0, 0);

        setAnimCart("anim_cart");
        setTimeout(() => setAnimCart(""), 1700);
    };

    const reqAddToCart = () => {
        if (quantity <= 0) return

        const lastLength = parseInt(cart.length);
        addToCart();

        if (lastLength === 0) setModal("cart");
    }

    return article && verif && (
        <article className='page page_article'>
            <button className="btn_return" onClick={() => goPage('shop')}>
                {'<'}- <span>{translations.return}</span> --
            </button>

            <p className="title_page">
                - <span>{article[`title_${language}`]}</span> -
            </p>

            <button
                className={"btn_show_cart " + animCart}
                onClick={() => setModal("cart")}
            >
                <p>{translations.cart}</p>
                <img src={icon_cart} alt="" />
            </button>

            <SelectLang />

            <section>
                <Slider images={article.images} />

                <div className="description">
                    <div className="textarea">
                        <span className="label">{translations.product_descrip} :</span>
                        <p className="value">{formatText(article[`descrip_${language}`])}</p>
                    </div>

                    <div className="field">
                        <span>{translations.price} :</span>
                        <p>{formatDecimal(article.price)} €</p>
                    </div>

                    {selected !== null &&
                        <div className="field field_selector">
                            <span>{article[`category_${language}`]} :</span>

                            <select value={selected} onChange={(e) => setSelected(e.target.value)}>
                                {article.selectors.map((category, idx) =>
                                    <option key={idx} value={idx}>{category[`name_${language}`]}</option>
                                )}
                            </select>
                        </div>
                    }

                    <div className="panel">
                        <div className="field field_selector">
                            <span>{translations.quantity} :</span>
                            <input
                                type="number"
                                value={quantity}
                                placeholder="0"
                                onChange={(e) => updateQuantity(e)}
                            />
                        </div>

                        <button onClick={() => reqAddToCart()}>
                            {translations.add_to_cart}
                        </button>
                    </div>
                </div>
            </section>


            {modal && cart &&
                <ModalShop modal={modal} setModal={setModal} />
            }
        </article>
    )
}

export default Article;